import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-930702a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loan-detail-page" }
const _hoisted_2 = { class: "card card-stretch shadow" }
const _hoisted_3 = { class: "card-body loan-detail-breadcrumb" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Лавлагаа")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Буцах ")
const _hoisted_8 = {
  key: 0,
  class: "card shadow"
}
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 1,
  class: "card shadow"
}
const _hoisted_11 = { class: "card-body empty-state" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Мэдээлэл олдсонгүй", -1))
const _hoisted_14 = { class: "loan-hero" }
const _hoisted_15 = { class: "loan-hero-meta" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-building me-2" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt me-2" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag-checkered me-2" }, null, -1))
const _hoisted_19 = { class: "summary-grid" }
const _hoisted_20 = { class: "detail-toolbar" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Дэлгэрэнгүй мэдээлэл"),
  /*#__PURE__*/_createElementVNode("span", null, "Энэ хуудсан дээрх бүх хүснэгтээс хайна.")
], -1))
const _hoisted_22 = { class: "detail-section" }
const _hoisted_23 = { class: "section-title" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-invoice-dollar" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Гол нөхцөл, төлөв, огноо, байгууллагын мэдээлэл", -1))
const _hoisted_26 = { class: "info-grid" }
const _hoisted_27 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-stream" }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Тухайн шугамаас авсан зээлүүд")
  ])
], -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Нээх ")
const _hoisted_31 = { class: "detail-section" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Барьцаа хөрөнгийн мэдээлэл"),
    /*#__PURE__*/_createElementVNode("p", null, "Барьцаа болон тухайн барьцааны эзэмшигчид")
  ])
], -1))
const _hoisted_33 = { class: "owners-panel" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Эзэмшигчид", -1))
const _hoisted_35 = {
  key: 0,
  class: "owners-empty"
}
const _hoisted_36 = {
  key: 1,
  class: "owner-list"
}
const _hoisted_37 = {
  key: 1,
  class: "detail-section"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-friends" }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Зээлтэй холбогдох этгээдүүд"),
    /*#__PURE__*/_createElementVNode("p", null, "Тухайн зээл дээр бүртгэлтэй холбогдох этгээдүүд")
  ])
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_40 = {
  key: 2,
  class: "detail-section"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-check" }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Зээлийн төлөлт, хуваарь"),
    /*#__PURE__*/_createElementVNode("p", null, "Төлөх хуваарь болон бодит төлөлтийн мэдээлэл")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/reference' } }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, "Зээлдэгчийн мэдээлэл")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.pageTitle), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "mini",
          type: "info",
          plain: "",
          onClick: _ctx.goBack
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.dataLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_skeleton, {
              rows: 8,
              animated: ""
            })
          ])
        ]))
      : (_ctx.loanDetailsNotFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("p", null, _toDisplayString(_ctx.emptyText), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("section", _hoisted_14, [
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", _ctx.isLoanLine ? 'badge-light-info' : 'badge-light-primary'])
                }, _toDisplayString(_ctx.loanDetails.obligationType), 3),
                _createElementVNode("h1", null, _toDisplayString(_ctx.displayCode), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.loanDetails.customerName || _ctx.customercode), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", null, [
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(_ctx.loanDetails.orgName ||
                _ctx.loanDetails.providerRegnum ||
                "Байгууллага -"), 1)
                ]),
                _createElementVNode("span", null, [
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(_ctx.loanDetails.starteddate || "Олгосон огноо -"), 1)
                ]),
                _createElementVNode("span", null, [
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(_ctx.loanDetails.paiddate || "Идэвхтэй / төлөгдөөгүй"), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryCards, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "summary-card"
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.label), 1),
                  _createElementVNode("strong", null, _toDisplayString(item.value), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_el_input, {
                modelValue: _ctx.tableSearch,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tableSearch) = $event)),
                clearable: "",
                placeholder: "Хайх...",
                "prefix-icon": "el-icon-search",
                size: "small"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("section", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", null, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.isLoanLine
                  ? "Зээлийн шугамын үндсэн мэдээлэл"
                  : "Зээлийн үндсэн мэдээлэл"), 1),
                  _hoisted_25
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailFields, (field) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: field.label,
                    class: "info-item"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(field.label), 1),
                    _createElementVNode("strong", null, _toDisplayString(field.value || "-"), 1)
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.isLoanLine)
              ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_el_table, {
                    data: _ctx.filteredRows(_ctx.subLoans),
                    border: "",
                    size: "mini",
                    "empty-text": _ctx.emptyText,
                    "cell-style": { textAlign: 'center' },
                    "header-cell-style": { textAlign: 'center' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "Зээлийн дугаар",
                        prop: "loanCode",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төрөл",
                        "min-width": "170"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.loanTypeName) + " ", 1),
                          (scope.row.subLoanTypeName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "- " + _toDisplayString(scope.row.subLoanTypeName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Ангилал",
                        prop: "loanClassName",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Олгосон огноо",
                        prop: "starteddate",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төлөгдөх огноо",
                        prop: "expdate",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Олгосон хэмжээ",
                        prop: "amountLcy",
                        width: "140"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Үлдэгдэл",
                        prop: "balanceLcy",
                        width: "140"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "Төлөв",
                        prop: "loanStatusName",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        fixed: "right",
                        label: "Дэлгэрэнгүй",
                        width: "120"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            size: "mini",
                            type: "primary",
                            plain: "",
                            onClick: ($event: any) => (_ctx.openSubLoan(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "empty-text"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_el_table, {
                data: _ctx.filteredRows(_ctx.collaterals),
                border: "",
                size: "mini",
                "empty-text": _ctx.emptyText,
                "cell-style": { textAlign: 'center' },
                "header-cell-style": { textAlign: 'center' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, { type: "expand" }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        (!scope.row.owners || scope.row.owners.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, " Эзэмшигчийн мэдээлэл байхгүй байна. "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.owners, (owner) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `${scope.row.collCode}-${owner.identityNo}`,
                                  class: "owner-item"
                                }, [
                                  _createElementVNode("strong", null, _toDisplayString(owner.subjectName), 1),
                                  _createElementVNode("span", null, _toDisplayString(owner.identityNo) + " / " + _toDisplayString(owner.stateRegisterNo), 1),
                                  _createElementVNode("small", null, _toDisplayString(owner.isCitizen === 1 ? "Иргэн" : "Хуулийн этгээд") + " · " + _toDisplayString(owner.isForeign === 1 ? "Гадаад" : "Дотоод"), 1)
                                ]))
                              }), 128))
                            ]))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Барьцааны дугаар",
                    prop: "collCode",
                    "min-width": "140"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.isLoanLine ? 'Хамаарах шугам' : 'Хамаарах зээл',
                    prop: _ctx.isLoanLine ? 'loanlineCode' : 'loanCode',
                    "min-width": "140"
                  }, null, 8, ["label", "prop"]),
                  _createVNode(_component_el_table_column, {
                    label: "Төрөл",
                    prop: "collSubName",
                    "min-width": "180"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "УБ дугаар",
                    prop: "collRegNum",
                    "min-width": "150"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Үнэлгээ хийсэн огноо",
                    prop: "valuationDate",
                    width: "140"
                  }),
                  _createVNode(_component_el_table_column, {
                    formatter: _ctx.$filters.formatPrice,
                    label: "Үнэлгээ",
                    prop: "value",
                    width: "140"
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    formatter: _ctx.$filters.formatPrice,
                    label: "Дээд хязгаар",
                    prop: "maxValue",
                    width: "140"
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: "Хаяг",
                    prop: "address",
                    "min-width": "220"
                  })
                ]),
                _: 1
              }, 8, ["data", "empty-text"])
            ]),
            (!_ctx.isLoanLine)
              ? (_openBlock(), _createElementBlock("section", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_el_table, {
                    data: _ctx.filteredRows(_ctx.relations),
                    border: "",
                    size: "mini",
                    "empty-text": _ctx.emptyText,
                    "cell-style": { textAlign: 'center' },
                    "header-cell-style": { textAlign: 'center' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "Хэлбэр",
                        prop: "relationModeName",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төрөл",
                        prop: "relationTypeName",
                        "min-width": "160"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "CIN / РД",
                        prop: "relationIdentityNo",
                        "min-width": "140"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "РД / УБД",
                        prop: "relationStateRegisterNo",
                        "min-width": "140"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Нэр",
                        prop: "relationSubjectName",
                        "min-width": "160"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Овог",
                        prop: "relationLastName",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Иргэн эсэх",
                        width: "115"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.isCitizen === 1 ? "Иргэн" : "Хуулийн этгээд"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Санхүүгийн үүрэгтэй",
                        width: "150"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.relationIsFinancial === 1 ? "Тийм" : "Үгүй"), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.canDeleteRelations)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            fixed: "right",
                            label: "Үйлдэл",
                            width: "95"
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_el_button, {
                                size: "mini",
                                type: "danger",
                                plain: "",
                                loading: _ctx.deletingRelationKey === _ctx.relationKey(scope.row),
                                onClick: ($event: any) => (_ctx.confirmDeleteRelation(scope.row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_39
                                ]),
                                _: 2
                              }, 1032, ["loading", "onClick"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data", "empty-text"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isLoanLine)
              ? (_openBlock(), _createElementBlock("section", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_el_tabs, { type: "border-card" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tab_pane, { label: "Хуваарь" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table, {
                            data: _ctx.filteredRows(_ctx.schedules),
                            border: "",
                            size: "mini",
                            "empty-text": _ctx.emptyText,
                            "cell-style": { textAlign: 'center' },
                            "header-cell-style": { textAlign: 'center' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                label: "Төлөгдөх огноо",
                                prop: "dueDate",
                                width: "130"
                              }),
                              _createVNode(_component_el_table_column, {
                                formatter: _ctx.$filters.formatPrice,
                                label: "Үндсэн төлбөр",
                                prop: "principal"
                              }, null, 8, ["formatter"]),
                              _createVNode(_component_el_table_column, {
                                formatter: _ctx.$filters.formatPrice,
                                label: "Хүү",
                                prop: "interest"
                              }, null, 8, ["formatter"]),
                              _createVNode(_component_el_table_column, {
                                formatter: _ctx.$filters.formatPrice,
                                label: "Нэмэлт",
                                prop: "additional"
                              }, null, 8, ["formatter"]),
                              _createVNode(_component_el_table_column, {
                                formatter: _ctx.$filters.formatPrice,
                                label: "Үлдэгдэл",
                                prop: "balance"
                              }, null, 8, ["formatter"])
                            ]),
                            _: 1
                          }, 8, ["data", "empty-text"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_tab_pane, { label: "Төлөлт" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table, {
                            data: _ctx.filteredRows(_ctx.payments),
                            border: "",
                            size: "mini",
                            "empty-text": _ctx.emptyText,
                            "cell-style": { textAlign: 'center' },
                            "header-cell-style": { textAlign: 'center' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                label: "Төлөгдөх огноо",
                                prop: "dueDate",
                                width: "130"
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Төлсөн огноо",
                                prop: "paidDate",
                                width: "130"
                              }),
                              _createVNode(_component_el_table_column, {
                                formatter: _ctx.$filters.formatPrice,
                                label: "Үндсэн төлбөр",
                                prop: "principal"
                              }, null, 8, ["formatter"]),
                              _createVNode(_component_el_table_column, {
                                formatter: _ctx.$filters.formatPrice,
                                label: "Хүү",
                                prop: "interest"
                              }, null, 8, ["formatter"]),
                              _createVNode(_component_el_table_column, {
                                formatter: _ctx.$filters.formatPrice,
                                label: "Нэмэлт",
                                prop: "additional"
                              }, null, 8, ["formatter"])
                            ]),
                            _: 1
                          }, 8, ["data", "empty-text"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 64))
  ]))
}